import { createClient } from "@supabase/supabase-js";

const url = process.env.REACT_APP_SUPABASE_URL;
const anonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

export const isSupabaseConfigured = Boolean(url && anonKey);

// ----------------------------------------------------
// PUBLIC USER CLIENT
// Homepage / Chat / Normal users
// ----------------------------------------------------
export const supabase =
  isSupabaseConfigured ?
    createClient(url, anonKey, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
        storageKey: "public-auth",
      },
    })
  : null;

// ----------------------------------------------------
// ADMIN CLIENT
// Admin panel only
// ----------------------------------------------------
export const adminSupabase =
  isSupabaseConfigured ?
    createClient(url, anonKey, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
        storageKey: "admin-auth",
      },
    })
  : null;

// ----------------------------------------------------
// Sync realtime auth token
// ----------------------------------------------------
export async function syncRealtimeAuth(client) {
  if (!client) return;

  const {
    data: { session },
  } = await client.auth.getSession();

  await client.realtime.setAuth(session?.access_token ?? null);
}

// ----------------------------------------------------
// Auto sync PUBLIC realtime
// ----------------------------------------------------
if (supabase) {
  const pushToken = (session) => {
    supabase.realtime.setAuth(session?.access_token ?? null);
  };

  supabase.auth.getSession().then(({ data: { session } }) => {
    pushToken(session);
  });

  supabase.auth.onAuthStateChange((_event, session) => {
    pushToken(session);
  });
}

// ----------------------------------------------------
// Auto sync ADMIN realtime
// ----------------------------------------------------
if (adminSupabase) {
  const pushToken = (session) => {
    adminSupabase.realtime.setAuth(session?.access_token ?? null);
  };

  adminSupabase.auth.getSession().then(({ data: { session } }) => {
    pushToken(session);
  });

  adminSupabase.auth.onAuthStateChange((_event, session) => {
    pushToken(session);
  });
}
